import ContentContainer from '../../../universal_components/ContentContainer/ContentContainer';
import styles from './InfoSection.module.scss';

const InfoSection = ({ text, text2, photo1, photo2 }) => {
  return (
    <section className={styles.infoSection}>
      <ContentContainer>
        <h2 className={styles.title}>Дополнительная информация</h2>
        <div className={styles.wrapper}>
          {(photo1 || photo2) && (
            <div className={styles.images}>
              {photo1 && <img src={photo1} alt="" />}
              {photo2 && <img src={photo2} alt="" />}
            </div>
          )}

          {text && <div className={styles.text} dangerouslySetInnerHTML={{ __html: text }} />}
          {text2 && <div className={styles.text} dangerouslySetInnerHTML={{ __html: text2 }} />}
        </div>
      </ContentContainer>
    </section>
  );
};

export default InfoSection;
